/** 1 кредит = 1 ₽, целые. */
export const rub = (n: number) => `${n.toLocaleString('ru-RU')} ₽`;
export const signedRub = (n: number) => `${n > 0 ? '+' : n < 0 ? '−' : ''}${Math.abs(n).toLocaleString('ru-RU')} ₽`;
export const num = (n: number) => n.toLocaleString('ru-RU');
export const usd = (n: number) => `$${n.toLocaleString('en-US', { maximumFractionDigits: 3 })}`;

const tz = 'Europe/Moscow';
export const time = (iso: string) => new Date(iso).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', timeZone: tz });
export const date = (iso: string) => new Date(iso).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short', timeZone: tz });
export const dateTime = (iso: string) =>
  new Date(iso).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: tz });

/** «08:14» сегодня, иначе «7 окт». */
export function when(iso: string): string {
  const d = new Date(iso);
  const today = new Date().toLocaleDateString('ru-RU', { timeZone: tz });
  return d.toLocaleDateString('ru-RU', { timeZone: tz }) === today ? time(iso) : date(iso);
}

export function seconds(sec: number | null | undefined): string {
  if (sec === null || sec === undefined) return '—';
  if (sec < 60) return `${sec} с`;
  return `${Math.floor(sec / 60)} мин ${sec % 60} с`;
}

export function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}

export const shortId = (id: string) => id.slice(0, 8);
export const userName = (u: { username: string | null; firstName: string }) => (u.username ? `@${u.username}` : u.firstName);
